// 首页
import request from '@/utils/request'

// 设备基本信息
export function findDeviceInfo(params) {
  if (!params.myToken) {
    return request({
      url: '/v3/report/findDeviceInfo',
      method: 'post',
      headers: { 'token': 'nmamtf' },
      data: params
    })
  } else {
    return request({
      url: '/v3/report/findDeviceInfo',
      method: 'post',
      data: params
    })
  }
}
// 充放电信息
export function getDeviceInfoByMcuId(params) {
  return request({
    url: '/v3/report/getDeviceInfoByMcuId',
    method: 'post',
    data: params
  })
}
// 表格中柱状图数据
export function getHourReport(params) {
  return request({
    url: '/v3/report/getHourReport',
    method: 'post',
    data: params
  })
}
// 获取警告信息
export function warningListByMcuId(params) {
  return request({
    url: '/v3/report/warningListByMcuId',
    method: 'post',
    data: params
  })
}
// 获取设备最后的位置
export function getGNSSLastByMcuID(params) {
  return request({
    url: '/v3/location/getGNSSLastByMcuID',
    method: 'post',
    data: params
  })
}
export function listWarningPushMsg(params) { // 周报--警告信息
  return request({
    url: 'v3/report/listWarningPushMsg',
    method: 'post',
    data: params
  })
}
export function getOdc(params) { // 周报--日数据
  return request({
    url: 'v3/report/getOdcByDay',
    method: 'post',
    data: params
  })
}
export function getOdcBMS(params) { // 周报--日数据--锂电池
  return request({
    url: 'v3/report/bms/getOdcByDay',
    method: 'post',
    data: params
  })
}
// 表格中柱状图数据--锂电池
export function getHourReportBMS(params) {
  return request({
    url: '/v3/report/bms/getHourReport',
    method: 'post',
    data: params
  })
}
export function listChargingDischarging(params) { // 充放电记录
  return request({
    url: 'v3/report/chargingDischarging/listChargingDischarging',
    method: 'post',
    data: params
  })
}
export function listChargingDischargingBMS(params) { // 充放电记录
  return request({
    url: 'v3/report/bms/chargingDischarging/listChargingDischarging',
    method: 'post',
    data: params
  })
}
// export function getDateByTimes2(params) { // 周报--弹窗折线图数据
//   console.log(params.index)
//   return request({
//     url: '/v2/report/getDataByTimes2?' +
//       'sn=' + params.sn + '&startDate=' + params.startDate + '&endDate=' + params.endDate + '&index=' + params.index + '&companyId=',
//     method: 'get'
//   })
// }
export function listRecordData(params) { // 周报--弹窗折线图数据
  return request({
    url: '/v3/report/listRecordData',
    method: 'post',
    data: params,
    responseType: 'arraybuffer'
  })
}
// 编辑设备信息弹窗--品牌型号下拉框
// export function deviceMechcascader() {
//   return request({
//     url: '/v2/deviceMech/cascader',
//     method: 'get'
//   })
// }
export function deviceMechcascader() {
  return request({
    url: 'v3/manager/deviceMech/cascader',
    method: 'get'
  })
}
// 编辑设备信息弹窗--提交
export function updateDeviceBind(params) {
  return request({
    url: '/v3/manager/updateDeviceBind',
    method: 'post',
    data: params
  })
}
// soh记录
export function listSohRecord(params) {
  return request({
    url: '/v3/report/count/listSohRecord?endTime=' + params.endTime + '&mcuId=' + params.mcuId + '&startTime=' + params.startTime,
    method: 'get',
    data: params
  })
}
// 手动计算soh
export function countSoh(params) {
  return request({
    url: '/v3/report/count/countSoh',
    method: 'post',
    data: params
  })
}
// 按事件统计ignition、hourMeter触发时间和相关数据--旧
export function getHourMeterEventStatisticsByDay(params) {
  return request({
    url: '/v3/report/getHourMeterEventStatisticsByDay?endTime=' + params.endTime + '&mcuId=' + params.mcuId + '&startTime=' + params.startTime + '&showAll=false',
    method: 'get',
    data: params
  })
}
// 按事件统计ignition、hourMeter触发时间和相关数据--新
export function pageHourMeterEventStatisticsByDay(params) {
  return request({
    url: '/v3/report/pageHourMeterEventStatisticsByDay',
    method: 'post',
    data: params
  })
}
// 获取每天总的工作时长和使用时长
export function getHourMeterStatisticsByDay(params) {
  return request({
    url: '/v3/report/getHourMeterStatisticsByDay?endTime=' + params.endTime + '&mcuId=' + params.mcuId + '&startTime=' + params.startTime + '&showAll=false',
    method: 'get',
    data: params
  })
}
//  获取每天具体的工作时段和使用时段
export function getHourMeterTimeStatisticsByDay(params) {
  return request({
    url: '/v3/report/getHourMeterTimeStatisticsByDay?endTime=' + params.endTime + '&mcuId=' + params.mcuId + '&startTime=' + params.startTime + '&showAll=false',
    method: 'get',
    data: params
  })
}

//重算充放电记录
export function calculateChargeDischarge(params) {
  return request({
    url: '/v3/report/chargingDischarging/countDodByCondition',
    method: 'post',
    data: params
  })
}

//重算充放电记录
export function calculateChargeDischargeBms(params) {
  return request({
    url: '/v3/report/bms/chargingDischarging/countDodByCondition',
    method: 'post',
    data: params
  })
}

//动态获取报表数据
export function getDynamicData(params) {
  return request({
    url: '/v3/report/getDynamicData?mcuId=' + params.mcuId + '&start=' + params.startTime + '&end=' + params.endTime + '&type=' + params.type,
    method: 'get'
  })
}